let TireDetailTiles = {
    
};